import { position } from '@store/Map.store';
import { LatLngBounds } from 'leaflet';
import React from 'react';
import { useMap, useMapEvents } from 'react-leaflet';
import { IProps as IMainProps } from './IProps';

interface IProps
    extends Pick<
        IMainProps,
        | 'position'
        | 'reload'
        | 'zoom'
        | 'onMapDrag'
        | 'onMapMove'
        | 'onMapZoom'
        | 'onReload'
    > {
    bounds: LatLngBounds | null;
}

const Component: React.FC<IProps> = ({
    bounds,
    position,
    zoom,
    onMapDrag,
    onMapMove,
    onMapZoom,
    reload,
    onReload,
}: IProps) => {
    const lat = position[0];
    const lon = position[1];
    const map = useMap();
    if (lat && lon) {
        const center: position = [lat, lon];
        map.setView(center, zoom);
    }
    if (reload) {
        setTimeout(() => {
            if (bounds) {
                map.fitBounds(bounds);
            } else {
                const center = map.getCenter();
                map.setView(center, zoom);
                map.invalidateSize();
            }
        }, 0);
        onReload();
    }
    if (bounds) {
        setTimeout(() => {
            map.fitBounds(bounds);
        }, 0);
    }
    useMapEvents({
        zoomend() {
            const zoom = map.getZoom();
            const { lat, lng } = map.getCenter();
            const position: position = [lat, lng];
            onMapZoom(zoom, position);
        },
        dragend() {
            const { lat, lng } = map.getCenter();
            onMapDrag([lat, lng]);
        },
        moveend() {
            onMapMove();
        },
    });
    return null;
};

const MapControlComponent = React.memo(Component);

export default MapControlComponent;
